import { AlertCircle, CheckCircle2, Info, X } from 'lucide-react';
import { useApp } from '../domain/AppContext';
import { formatClassCodesInText } from '../domain/classCode';

export function ToastViewport() {
  const { toasts, dismissToast } = useApp();
  return (
    <div className="toast-viewport" aria-live="polite" aria-atomic="false">
      {toasts.map((toast) => {
        const Icon = toast.type === 'success' ? CheckCircle2 : toast.type === 'error' ? AlertCircle : Info;
        return (
          <div className={`toast toast-${toast.type}`} key={toast.id} role="status">
            <Icon size={20} aria-hidden="true" />
            <div><strong>{formatClassCodesInText(toast.title)}</strong>{toast.description ? <p>{formatClassCodesInText(toast.description)}</p> : null}</div>
            <button type="button" aria-label="Fechar mensagem" onClick={() => dismissToast(toast.id)}><X size={16} /></button>
          </div>
        );
      })}
    </div>
  );
}
